"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterViewConfig = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

var _filterCollectionView = _interopRequireDefault(require("./filters/filter-collection-view"));

var _chipView = _interopRequireDefault(require("./filters/chip-view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FilterViewConfig = {
  expandFiltersOnLoad: false,
  hideToggleButton: false,
  useFreeTextSearch: false
};
exports.FilterViewConfig = FilterViewConfig;

var FilterView = function FilterView(_ref) {
  var onToggleShowFilters = _ref.onToggleShowFilters,
      filtersVisible = _ref.filtersVisible,
      filters = _ref.filters,
      onChange = _ref.onChange,
      onFreeTextSearchChange = _ref.onFreeTextSearchChange,
      onClearAll = _ref.onClearAll,
      dictionary = _ref.dictionary;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      freeTextSearch = _useState2[0],
      setFreeTextSearch = _useState2[1];

  (0, _react.useEffect)(function () {
    onFreeTextSearchChange(freeTextSearch);
  }, [freeTextSearch]);

  var onLocalFreeTextSearchChange = function onLocalFreeTextSearchChange(value) {
    setFreeTextSearch(value);
  };

  if (FilterViewConfig.expandFiltersOnLoad) {
    filtersVisible = true;
  }

  var handleFilterButtonClick = function handleFilterButtonClick(e) {
    e.preventDefault();
    onToggleShowFilters();
  };

  var handleFilterElementChange = function handleFilterElementChange(element) {
    element.selected = !element.selected;
    onChange(element);
  };

  var handleChipCloseClick = function handleChipCloseClick(filterElement) {
    filterElement.selected = false;
    onChange(filterElement);
  };

  var handleClearAllClick = function handleClearAllClick(e) {
    e.preventDefault();
    onClearAll();
  };

  var selectedFilterElements = filters.map(function (filter) {
    return filter.elements.filter(function (element) {
      return element.selected;
    });
  }).flat();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "filters"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "main__inner"
  }, !FilterViewConfig.hideToggleButton && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button toggle-button",
    onClick: handleFilterButtonClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "toggle-button__label"
  }, dictionary.filterby)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "summary-container"
  }, !!selectedFilterElements.length && /*#__PURE__*/_react["default"].createElement("div", {
    className: "summary-container__filter-summary"
  }, selectedFilterElements.length, ' ', "filters applied"), selectedFilterElements.map(function (el) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "summary-container__chip",
      key: el.id
    }, /*#__PURE__*/_react["default"].createElement(_chipView["default"], {
      filterElement: el,
      onCloseClick: handleChipCloseClick,
      className: ""
    }));
  }), !!selectedFilterElements.length && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "clear-all-button",
    onClick: handleClearAllClick
  }, dictionary.viewall))), FilterViewConfig.useFreeTextSearch && /*#__PURE__*/_react["default"].createElement("div", {
    className: "main__free-text-search"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: "free-text-search",
    type: "text",
    onChange: function onChange(event) {
      onLocalFreeTextSearchChange(event.target.value);
    },
    value: freeTextSearch,
    placeholder: dictionary.freetextsearch
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      onLocalFreeTextSearchChange('');
    }
  }, dictionary.clearfreetext))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "details ".concat(filtersVisible ? '' : 'details--hidden')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "details__inner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "collection-container"
  }, filters.map(function (filter) {
    return /*#__PURE__*/_react["default"].createElement(_filterCollectionView["default"], {
      key: filter.id,
      filter: filter,
      onChange: handleFilterElementChange
    });
  })), !FilterViewConfig.hideToggleButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "details__footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button close-filters-button",
    onClick: handleFilterButtonClick
  }, dictionary.closefilters)))));
};

FilterView.propTypes = {
  filtersVisible: _propTypes["default"].bool,
  onToggleShowFilters: _propTypes["default"].func,
  // eslint-disable-next-line react/forbid-prop-types
  filters: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  onFreeTextSearchChange: _propTypes["default"].func,
  onClearAll: _propTypes["default"].func,
  dictionary: _propTypes2["default"].dictionary.isRequired
};
FilterView.defaultProps = {
  filtersVisible: false,
  onToggleShowFilters: function onToggleShowFilters() {
    return null;
  },
  filters: [],
  onChange: function onChange() {
    return null;
  },
  onFreeTextSearchChange: function onFreeTextSearchChange() {
    return null;
  },
  onClearAll: function onClearAll() {
    return null;
  }
};
var _default = FilterView;
exports["default"] = _default;